const ANIMAL_GENDER = Object.freeze({
  MOSKI: {
    id: "MOSKI",
    code: 1,
    translationKey: "animal.sex.MALE",
  },
  ZENSKI: {
    id: "ZENSKI",
    code: 2,
    translationKey: "animal.sex.FEMALE",
  },
  DVOSPOLNIK: {
    id: "DVOSPOLNIK",
    code: 3,
    translationKey: "animal.sex.INTERSEX",
  },
  NEZNAN: {
    id: "NEZNAN",
    code: 4,
    translationKey: "animal.sex.UNKNOWN",
  },
  KASTRAT: {
    id: "KASTRAT",
    code: 5,
    translationKey: "animal.sex.CASTRATED",
  },
  KRIPTOHID: {
    id: "KRIPTOHID",
    code: 6,
    translationKey: "animal.sex.KRIPTOHID",
  },
});

export const SHEEP_GOAT_GENDER_LIST = Object.freeze([
  ANIMAL_GENDER.MOSKI,
  ANIMAL_GENDER.ZENSKI,
  ANIMAL_GENDER.DVOSPOLNIK,
  ANIMAL_GENDER.KASTRAT,
]);

export default ANIMAL_GENDER;
